import { render } from "./NewHeaderSection.vue?vue&type=template&id=59b7fee2&scoped=true&ts=true"
import script from "./NewHeaderSection.vue?vue&type=script&lang=ts"
export * from "./NewHeaderSection.vue?vue&type=script&lang=ts"

import "./NewHeaderSection.vue?vue&type=style&index=0&id=59b7fee2&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59b7fee2"]])

export default __exports__